import { createContext, useContext } from 'react';

export interface FavouriteStoresContextType {
  stores: Record<number, boolean>;
  updateStore: (merchantId: number, isFavourite: boolean) => Promise<void>;
}

export const FavouriteStoresContext = createContext<FavouriteStoresContextType>(
  {
    stores: {},
    updateStore: async () => {
      // do nothing. This will be set when provider is used
    },
  }
);

export const useFavouriteStoresContext = (): FavouriteStoresContextType => {
  return useContext(FavouriteStoresContext);
};
